import BasicModal from '__components/Modals/presets/BasicModal';
import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

interface WarningModalProps {
  onConfirm: (...args: any[]) => any;
  onHide: (...args: any[]) => any;
  show: boolean;
}

export const NoPermissionModal = ({
  onConfirm,
  onHide,
  show = false,
}: WarningModalProps) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <BasicModal
      heading={t('Finish Plugin Installation')}
      buttonText={t('Continue')}
      actionBtnColor="blue"
      onConfirm={onConfirm}
      onHide={onHide}
      show
      leftBtn={false}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'This plugin requires secrets to be configured. Contact your Kizen administrator to finish plugin installation.'
          )}
        </Typography>
      </div>
    </BasicModal>
  );
};
